import React, { useState } from 'react';

function Drag() {
  const [items, setItems] = useState(['com1', 'com2', 'com3', 'com4']);
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (event, index) => {
    event.dataTransfer.setData("text/plain", index);
    setDraggedIndex(index);
  };

  const handleDragOver = (event, index) => {
    event.preventDefault();
  };

  const handleDrop = (event, index) => {
    event.preventDefault();
    const droppedIndex = parseInt(event.dataTransfer.getData("text/plain"));
    if (droppedIndex !== index) {
      const newItems = [...items];
      const draggedItem = newItems[draggedIndex];
      newItems.splice(draggedIndex, 1);
      newItems.splice(index, 0, draggedItem);
      setItems(newItems);
    }
  };

  return (
    <div className='flex justify-center items-center flex-col w-full h-full gap-10'>
      {items.map((item, index) => (
        <div
          key={index}
          draggable
          onDragStart={(event) => handleDragStart(event, index)}
          onDragOver={(event) => handleDragOver(event, index)}
          onDrop={(event) => handleDrop(event, index)}
          className='w-6/12 bg-red-200 rounded h-12 mt-10'
          style={{ cursor: 'move' }}
        >
          {item}
        </div>
      ))}
    </div>
  );
}

export default Drag;
